"use client";

/**
 * Full-viewport gate/loading screen shared by the embedded-copilot shells —
 * the Office add-in shell (`office-addin/office-shell.tsx`) and the Procore
 * auth gate (`procore/procore-auth-gate.tsx`). Each shell owns its own auth
 * lifecycle (MSAL NAA vs sign-in popup); this is just the shared presentation
 * (spinner, optional icon/title/error, optional action button) so the two
 * don't keep byte-identical markup in sync.
 */
import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export function EmbeddedGateScreen(t0) {
  const $ = _c(17);
  const {
    spinner,
    icon,
    title,
    message,
    error,
    action
  } = t0;
  let t1;
  if ($[0] !== spinner) {
    t1 = spinner && <div className="size-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />;
    $[0] = spinner;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = title && <h2 className="font-semibold text-lg">{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== message) {
    t3 = <p className="text-muted-foreground text-sm">{message}</p>;
    $[4] = message;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== error) {
    t4 = error && <p className="rounded-lg bg-destructive/10 px-3 py-2 text-destructive text-xs">{error}</p>;
    $[6] = error;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== action) {
    t5 = action && <button className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-2.5 font-medium text-primary-foreground text-sm transition-colors hover:bg-primary/90" onClick={action.onClick} type="button">{action.label}</button>;
    $[8] = action;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== icon || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className="flex h-dvh items-center justify-center bg-background p-6 text-foreground"><div className="flex max-w-sm flex-col items-center gap-4 text-center">{t1}{icon}{t2}{t3}{t4}{t5}</div></div>;
    $[10] = icon;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}